import { useEffect, useState } from "react";

import ScrollUpButton from "../../assets/icon/ScrollUpButton";
import { useAppSelector } from "../../hooks/redux-hooks";
import { selectMainState } from "../../store/slices/main";

const ScrollUp = () => {
  const [scroll, setScroll] = useState(0);
  const { radioPlayer, audioPlayer } = useAppSelector(selectMainState);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  const handleUpButton = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {radioPlayer.overTop || audioPlayer.overTop ? (
        <button
          className={
            scroll > 300
              ? "right-10 bottom-[7rem] fixed inline-block p-3 bg-orange text-white font-medium text-xs leading-tight rounded-full shadow-md hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg"
              : "hidden opacity-0"
          }
          onClick={handleUpButton}
        >
          <ScrollUpButton />
        </button>
      ) : (
        <button
          className={
            scroll > 300
              ? "right-10 bottom-[3rem] fixed inline-block p-3 bg-orange text-white font-medium text-xs leading-tight rounded-full shadow-md hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0  active:shadow-lg"
              : "hidden opacity-0"
          }
          onClick={handleUpButton}
        >
          <ScrollUpButton />
        </button>
      )}
    </>
  );
};

export default ScrollUp;
